import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { getTranslation } from '@language';
import { BaseNestedFieldDefinition } from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { FormSelectOption } from '../../../../../form-controls/entities/form-select-option.entity';
import { FieldReadHelper } from '../../../../../profile-form/helpers/fields/field-read.helper';
import { BatchFieldReadHelper } from '../../../../helpers/fields/batch-field-read.helper';
import { VisibleProfileFieldChildren } from '../../../../helpers/visible-profile-field-children.helper';
import { ShComplexInputFieldComponent } from '../complex-input-field/complex-input-field.component';

@Component({
    standalone: false,
    selector: 'sh-multi-item-field',
    templateUrl: './multi-item-input-field.component.html'
})
export class ShMultiItemInputFieldComponent extends ShComplexInputFieldComponent {
    public options$!: Observable<FormSelectOption[]>;

    public typeLabel$!: Observable<string>;

    constructor(protected fieldHelper: FieldReadHelper) {
        super(fieldHelper);
        this.initMultiItemInputStreams();
    }

    private initMultiItemInputStreams(): void {
        this.typeLabel$ = this.profileField$.pipe(
            map(profileField => {
                const translation: string | null = getTranslation(
                    this.translateService,
                    profileField.FieldDefinition.FlatKey,
                    'Type'
                );
                return translation ? translation : profileField.DisplayLabel;
            })
        );

        this.options$ = this.profileField$.pipe(
            map((profileField: ExtendedBaseProfileField) => VisibleProfileFieldChildren(profileField)),
            map((children: BaseNestedFieldDefinition[]) =>
                children.map(child => ({ label: child.Label ?? '', value: child.Key }))
            )
        );
    }

    init(profileField: ExtendedBaseProfileField, records: PartialRecord[], control: UntypedFormControl): void {
        const values = this.isBatchEdit
            ? BatchFieldReadHelper.getBatchFieldValue(profileField.FieldDefinition)
            : this.fieldHelper.getMergedMultiItemFieldValue(profileField.FieldDefinition, records);

        control.setValue(values);
    }
}
